import PropTypes from 'prop-types';
import {Button} from 'front-onceforall-core';
import {I18n} from 'react-redux-i18n';

function ReinviteOrganisationView({onReinvite}) {
  return (
    <Button
      icon="redo"
      onClick={onReinvite}
    >
      {I18n.t('subcontractor.reinvite.action')}
    </Button>
  );
}

ReinviteOrganisationView.propTypes = {
  onReinvite: PropTypes.func.isRequired
};

export default ReinviteOrganisationView;
